const colours = {
  orange: {
    light: '#ffad42',
    medium: '#f57c00',
    dark: '#bb4d00'
  },
  darkOrange: {
    light: '#ff844c',
    medium: '#f4511e',
    dark: '#b91400'
  },
  red: {
    light: '#ff6f60',
    medium: '#e53935',
    dark: '#ab000d'
  },
  pink: {
    light: '#ff6090',
    medium: '#e91e63',
    dark: '#b0003a'
  },
  purple: {
    light: '#9a67ea',
    medium: '#7e47e0',
    dark: '#662fc7'
  },
  blue: {
    light: '#6ec6ff',
    medium: '#2196f3',
    dark: '#0069c0'
  },
  teal: {
    light: '#62efff',
    medium: '#00bcd4',
    dark: '#008ba3'
  },
  green: {
    light: '#76d275',
    medium: '#43a047',
    dark: '#00701a'
  },
  yellow: {
    light: '#ffe54c',
    medium: '#ffb300',
    dark: '#c68400'
  }
}

export default colours